import { ToggleSwitch } from '@monofe/ui-common';
import type { IHamburgerSideMenuDownloadViewProperties } from './interface';
import { classNameForElement, StyleElement, styleForElement } from './SideMenuDownloadView.style';

function SideMenuDownloadView(properties: IHamburgerSideMenuDownloadViewProperties): JSX.Element {
    const style = (element: StyleElement) => styleForElement(element, properties);
    const className = (element: StyleElement) => classNameForElement(element, properties);

    return (
        <div className={className(StyleElement.Container)} style={style(StyleElement.Container)}>
            <h3 className={className(StyleElement.TitleText)} style={style(StyleElement.TitleText)}>
                {properties.title.text}
            </h3>
            <ToggleSwitch
                className={className(StyleElement.ToggleSwitch)}
                style={style(StyleElement.ToggleSwitch)}
                isOn={properties.isDownloaded}
                onCheck={properties.onChange}
            />
        </div>
    );
}

export default SideMenuDownloadView;
